<template>
  <el-card class="news-list-card" :style="{ backgroundColor: badgeColor }">
    <div slot="header" class="elHeader">
      <div class="card-header">
        <div class="news-source">
          <span class="news-badge">
            <img
              :src="badgeImg"
              class="news-badge-img"
              width="100%"
              height="100%"
            />
          </span>
          <h3>{{ title }}</h3>
          <span class="update-time">{{ maxLastUpTime }} 更新</span>
        </div>
        <div class="header-actions">
          <el-button type="text" icon="el-icon-refresh" circle @click="Refresh"></el-button>
        </div>
      </div>
    </div>
    <div class="news-list">
      <el-scrollbar vertical="true" class="scroll-container">
        <div v-for="(news, index) in newsList" :key="index" class="news-item">
          <div class="news-title">
            <span class="news-content">
              <a :href="news.link" target="_blank" rel="noopener noreferrer">{{ news.title }}</a>
            </span>
            <span v-if="news.val" class="news-val">{{ news.val }}</span>
            <span class="news-time">{{ news.lastUpTime }}</span>
          </div>
        </div>
      </el-scrollbar>
    </div>
  </el-card>
</template>

<script>
export default {
  name: "WidgetNewsList",
  data() {
    return {
      newsList: [],
      title: "",
      maxLastUpTime: "",
      badgeImg: "",
      badgeColor: "#4a1a2c",
    };
  },
  methods: {
    // 格式化时间：将2026-01-26T17:00:46.86861格式改为2026-01-26 17:00:46
    formatTime(timeStr) {
      if (!timeStr) return "";

      // 处理ISO格式时间
      const date = new Date(timeStr);
      if (isNaN(date.getTime())) return timeStr;

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    SetData(newsList, title, badgeImg, badgeColor) {
      this.badgeImg = "images/newslogo/" + badgeImg;
      this.badgeColor = badgeColor;
      // 格式化时间并找出最大的lastUpTime
      let maxTime = null;
      const formattedNewsList = newsList.map((news) => {
        // 格式化lastUpTime
        const formattedTime = this.formatTime(news.lastUpTime);

        // 更新新闻对象
        const updatedNews = {
          ...news,
          lastUpTime: formattedTime,
        };

        // 比较时间，找出最大值
        if (formattedTime) {
          const currentTime = new Date(formattedTime).getTime();
          if (!maxTime || currentTime > maxTime.time) {
            maxTime = {
              time: currentTime,
              formatted: formattedTime,
            };
          }
        }

        return updatedNews;
      });

      this.newsList = formattedNewsList;
      this.title = title;
      this.maxLastUpTime = maxTime ? maxTime.formatted : "";
    },
    Refresh() {
      this.$emit('refresh');
    },
  },
};
</script>

<style lang="scss" scoped>
.news-list-card {
  border-radius: 8px;
  overflow: hidden;
  color: #ffffff;
  border: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;

    .news-source {
      display: flex;
      align-items: center;
      gap: 12px;

      .news-badge {
        display: inline-block;
        width: 24px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        color: white;
        border-radius: 4px;
        font-size: 12px;
        font-weight: bold;
      }

      h3 {
        margin: 0;
        font-size: 18px;
        font-weight: 600;
        color: #ffffff;
      }

      .update-time {
        font-size: 12px;
        color: #d1b3c4;
      }
    }

    .header-actions {
      display: flex;
      gap: 8px;

      .el-button {
        color: #d1b3c4;

        &:hover {
          color: #ffffff;
        }
      }
    }
  }

  .news-list {
    padding: 0;
    height: calc(100% - 70px);
    overflow-y: auto;
    overflow-x: hidden;

    /* 自定义滚动条样式 */
    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: rgba(255, 255, 255, 0.1);
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(255, 255, 255, 0.3);
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: rgba(255, 255, 255, 0.5);
    }

    .news-item {
      padding: 12px 20px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);

      &:last-child {
        border-bottom: none;
      }

      .news-title {
        display: flex;
        align-items: center;
        gap: 8px;

        .news-content {
          font-size: 14px;
          color: #ffffff;
          line-height: 1.4;
          flex: 1;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          a {
            color: #ffffff;
            display: block;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .news-val {
          font-size: 14px;
          color: #ff6b6b;
          font-weight: bold;
        }

        .news-time {
          font-size: 12px;
          color: #d1b3c4;
          white-space: nowrap;
        }
      }
    }
  }
}

.scroll-container {
  white-space: nowrap;
  position: relative;
  overflow: hidden;
  width: 100%;
  ::v-deep {
    .el-scrollbar__bar {
      bottom: 0px;
    }
    .el-scrollbar__wrap {
      height: 569px;
    }
  }
}
</style>